export const route = {
  CREATE_BOOKING_API: "/bookings/create-booking",
  GET_OPPORTUNITY_DETAILS: "/bookings/get-opportunity-details",
  GET_BOOKING_DATA: "/bookings/get-booking",
  GET_BOOKING_PDF: "/bookings/get-booking-pdf",
  UPDATE_BOOKING_DATA: "/bookings/update-booking",
  CREATE_REFERRALS: "/referrals/create-lead",
  GET_TERMS_AND_CONDITION: "/project-terms",
  GET_MASTER_DATA: "/bookings/get-masters",
  GET_PRESIGNED_URL: "/aws/pre-signed-url",
  ACTIVATE_INVITATION: "/bookings/activate-invitation",
  DELETE_IMAGE: "/aws/delete-file",
  RESEND_NOTIFICATION: "/bookings/resend-notification",
  UPDATE_DELETE_IMAGE: "/bookings/update-images",
  SAVE_RATING_FEEDBACK: "/bookings/save-rating-feedback",
  DELETE_BOOKING: "/bookings/delete-booking",
  REFERRAL_DETAILS: "/referrals/get-referrals",
  GET_BOOKING_DOCUMENTS: "/booking-documents/pre-booking",
  UPDATE_REFERRER_DETAILS: "/bookings/update-referrer-details",
  UPDATE_APPLICANT_DATA: "/bookings/update-applicant",
  UPDATE_OTHER_DATA: "/bookings/update-other-details",
  UPDATE_UNIT_DATA: "/bookings/update-unit-details",
  UPDATE_PAYMENT_DATA: "/bookings/update-payment-details",
  UPDATE_DOCUMENT_COMMENT: "/bookings/update-document-comment",
  UPDATE_AGREED_TERMS: "/bookings/agreed-on-terms",
  UPDATE_SUBMIT_FOR_SIGNATURE: "/bookings/submit-for-signature",
  UPDATE_REFERRER_DATA_BOOKING_FORM: "/bookings/update-referrer-data",
  GET_VOUCHER_BY_VOUCHER_ID: "/vouchers/get-voucher-form",
  UPDATE_VOUCHER_APPLICANT_DETAILS: "/vouchers/update-applicant",
  CREATE_RAZORPAY_ORDER: "/payments/create-order",
  VOUCHER_UPDATE_PAYMENT_DATA: "/vouchers/update-payment-details",
  VOUCHER_PAYMENT_VERIFY: "/payments/verify",
  UPDATE_EOI_DETAILS: "/vouchers/update-eoi-details",
  SEND_OTP: "/vouchers/send-otp",
  SEND_EOI_FORM_LINK: "eoi-management/send-form-link/",
  VERIFY_OTP: "/vouchers/verify-otp",
  RESEND_OTP: "/vouchers/resend-otp",
  ENABLE_EDIT: "vouchers/enable-edit-form",
  BUY_NEW_VOUCHER: "vouchers/buy-new-voucher",
  DELETE_VOUCHER_APPLICANT: "vouchers/delete-applicant-details",
  CREATE_CP_VOUCHER_FORM: "vouchers/create-cp-voucher-form",
  GET_CHANNEL_PARTNER_BY_ID: "channel-partners/get-by-link",
  DELETE_TRANSACTIONS: "/vouchers/delete-payment-details",
  GET_COMPANY_DETAILS: "decentro/get-gst-details",
  CREATE_BOOKING_API_NEW: "/bookings/create-booking",
  UPDATE_COMPANY_DOCUMENTS: "/bookings/company-documents",
  GET_DIGILOCKER_URL: "/decentro/generate-digilocker-url",
  DELETE_BOOKINGS_TRANSACTIONS: "/bookings/delete-payment-details",
  UPDATE_COMPANY_DETAILS: "/bookings/update-company-details",
  UPDATE_SIGNATORY: "/bookings/update-signatory",
  GET_IMAGE_DETAILS_OCR: "/decentro/get-image-details",
  GET_COUNTRY_LIST: "/country-master",
  VERIFY_DIGILOCKER_STATUS: "/decentro/verify-digilocker-status",
  COMPRESS_IMAGE: "/compress-image",
  DELETE_APPLICANT: "/bookings/delete-applicant",
  MULTI_BOOKING_LIST: "sales/get-group-details",
  REQUEST_CANCELLATIONS: "/vouchers/request-cancellation",
  GROUP_APPLICANTS: "/sales/get-group-applicants",
  UPDATE_APPLICANT_MAPPING: "/bookings/map-applicants",
  GET_EOI_CAMPAIGN_DETAILS:'eoi-campaign/campaign-details',
  GET_MY_VOUCHER_LIST:'/vouchers/my-voucher-list',
  EOI_EXPORT_AS_PDF: 'vouchers/download-pdf'
};
